import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { suppressScrollReset } from './dashboard/marketing/navIntent';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // A cross-tab deep link inside the marketing dashboard (e.g. the setup
    // checklist's "Add domain") changes the route AND scrolls to a section
    // itself — this reset would otherwise win that race and snap the page
    // back to the top mid-animation. See navIntent.js's suppressScrollReset
    // for why a short time window, not just "is an intent still pending", is
    // what's actually needed here.
    if (suppressScrollReset()) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
